import React from 'react';
import styled from 'styled-components';
import privacyPolicyImg from '../assets/privacypolicy.png';

// Styled components
const PublicationsContainer = styled.section`
  background-color: #333;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PublicationTitle = styled.h2`
  color: white;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  &:after {
    content: '';
    display: block;
    width: 70px;
    height: 4px;
    background-color: #2196f3;
    margin: 0 auto;
  }
`;

const PaperCard = styled.div`
  display: grid;
  grid-template-columns: minmax(150px, 300px) 1fr;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
  width: 100%; // Take the full width of the parent
  max-width: 800px; // Set a max-width for the entire card
  box-sizing: border-box; // Include padding and border in the element's total width and height
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 1rem;
  }
`;

const PaperImage = styled.img`
  width: 100%;
  max-width: 300px; // Ensure the image does not exceed this width
  height: auto;
  border: 3px solid #888888;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;


const PaperDetails = styled.div`
  text-align: left;
`;

const PaperTitle = styled.h3`
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #2196f3;
`;

const Conference = styled.p`
  color: #ccc;
  margin-bottom: 0.5rem;
`;

const Authors = styled.p`
  color: #aaa;
  margin-bottom: 1rem;
  font-style: italic;
`;

const PaperButton = styled.a`
  display: inline-block;
  background-color: transparent; // Transparent background
  color: #2196f3; // Blue text color
  padding: 10px 15px;
  border: 1px solid #2196f3; // Blue border
  border-radius: 5px;
  text-decoration: none;
  &:hover {
    background-color: #2196f3; // Blue background on hover
    color: white; // White text on hover
  }
`;

const ComingSoonBadge = styled.span`
  display: inline-block;
  background-color: rgba(136, 136, 136, 0.2);
  color: #aaa;
  padding: 10px 15px;
  border: 1px solid #666;
  border-radius: 5px;
  font-style: italic;
`;

// Mock data
const publications = [
  {
    imageUrl: privacyPolicyImg,
    title: "Modernizing Privacy Policy Analysis with LLMs",
    journal: "Under Review, 2025",
    authors: "Mihir Trivedi et al.",
    paperUrl: null
  },
  {
    imageUrl: "https://www.mdpi.com/mathematics/mathematics-10-03626/article_deploy/html/images/mathematics-10-03626-g002-550.jpg",
    title: "Blockchain and Deep Learning-Based Fault Detection Framework for Electric Vehicles",
    journal: "Mathematics, MDPI 2022",
    authors: "Mihir Trivedi, Riya Kakkar, Rajesh Gupta, Sudeep Tanwar",
    paperUrl: "https://www.mdpi.com/2227-7390/10/19/3626"
  },
  {
    imageUrl: "https://onlinelibrary.wiley.com/cms/asset/a7519b6c-a73c-4d61-88a8-9707924a5260/etep9761157-fig-0001-m.png",
    title: "SV2G-ET: A Secure Vehicle-to-Grid Energy Trading Scheme Using Deep Reinforcement Learning",
    journal: "International Transactions on Electrical Energy Systems, Wiley 2022",
    authors: "Aparna Kumari, Mihir Trivedi, Sudeep Tanwar",
    paperUrl: "https://www.hindawi.com/journals/itees/2022/9761157/"
  },
];

const PublicationsSection = () => {
  return (
    <PublicationsContainer id = "publications">
      <PublicationTitle>Publications</PublicationTitle>
      {publications.map((paper, index) => (
        <PaperCard key={index}>
          <PaperImage src={paper.imageUrl} alt={paper.title} />
          <PaperDetails>
            <PaperTitle>{paper.title}</PaperTitle>
            <Conference>{paper.journal}</Conference>
            <Authors>{paper.authors}</Authors>
            {paper.paperUrl ? (
              <PaperButton href={paper.paperUrl} target="_blank" rel="noopener noreferrer">
                View Paper
              </PaperButton>
            ) : (
              <ComingSoonBadge>Coming Soon</ComingSoonBadge>
            )}
          </PaperDetails>
        </PaperCard>
      ))}
    </PublicationsContainer>
  );
};

export default PublicationsSection;


